import React from 'react';
import { Group, Stack, Title, Text, ThemeIcon } from '@mantine/core';

interface BenchTopHeaderProps {
    icon: React.ReactNode;
    title: string;
    description?: string;
    iconColor?: string;
}

const BenchTopHeader: React.FC<BenchTopHeaderProps> = ({
    icon,
    title,
    description,
    iconColor = "brand.4"
}) => {
    return (
        <Group spacing="md" align="center" noWrap mb="md">
            <ThemeIcon
                size={44}
                radius="md"
                variant="filled"
                color={iconColor}
            >
                {React.cloneElement(icon as React.ReactElement, { size: 28 })}
            </ThemeIcon>

            <Stack spacing={0}>
                <Title order={3} sx={{ fontWeight: 600, lineHeight: 1.2 }}>
                    {title}
                </Title>
                {description && (
                    <Text color="dimmed" size="sm" weight={400}>
                        {description}
                    </Text>
                )}
            </Stack>
        </Group>
    );
};

export default BenchTopHeader;